import { render } from "./StudentWithTrainingsBar.vue?vue&type=template&id=bd06cdc8&scoped=true"
import script from "./StudentWithTrainingsBar.vue?vue&type=script&lang=js"
export * from "./StudentWithTrainingsBar.vue?vue&type=script&lang=js"

import "./StudentWithTrainingsBar.vue?vue&type=style&index=0&id=bd06cdc8&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd06cdc8"]])

export default __exports__